import {
  Box,
  Icon,
  MediumIcon,
  Text,
  type ThemeColors,
} from '@factorialco/deprecated-design-system'

export type Type = 'link' | 'unlink'

type CalloutProps = {
  description: string
  type: Type
}

const CustomCallout: React.FC<CalloutProps> = ({ description, type }) => {
  const icons: Record<Type, MediumIcon> = {
    link: 'link',
    unlink: 'link-remove',
  }

  const backgroundColor: Record<Type, ThemeColors> = {
    link: 'actionPositiveBackground',
    unlink: 'warningBackground',
  }

  const iconColors: Record<string, ThemeColors> = {
    link: 'iconLink',
    unlink: 'iconWarning',
  }

  const textColors: Record<string, ThemeColors> = {
    link: 'feedbackPositive',
    unlink: 'feedbackWarning',
  }

  return (
    <Box
      flexDirection="column"
      gap="s12"
      paddingX="s16"
      paddingY="s12"
      borderRadius={{ all: 'abs016' }}
      background={backgroundColor[type]}
    >
      <Box flexDirection="column" gap="s8">
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Box width="s24">
            <Icon.Medium icon={icons[type]} color={iconColors[type]} />
          </Box>
          <Box flexDirection="row" gap="s8" alignItems="center" flexGrow>
            <Box flexGrow>
              <Text.Normal size="300" overflowWrap ellipsis color={textColors[type]}>
                {description}
              </Text.Normal>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CustomCallout
